
































import { Component, Vue, Prop } from "vue-property-decorator";
import { Transaction } from "@foxone/api/src/models/defi";
import utils from "defi/utils";

@Component
class TransactionItem extends Vue {
  @Prop() transaction!: Transaction;

  @Prop() last!: boolean;

  @Prop() first!: boolean;

  get meta() {
    const status = utils.enums.getTransactionStatusMeta(
      this.transaction.status
    );
    return {
      symbol: this.transaction.asset.symbol.toUpperCase(),
      icon: this.transaction.asset.icon,
      name: this.transaction.product_name,
      amount: this.$common.utils.number.addSymbol(this.transaction.quantity),
      amountColor: this.$common.utils.helper.getColor(
        this.$store,
        this.transaction.quantity
      ),
      type: utils.enums.getTransactionTypeMeta(this.transaction.type),
      statusText: this.$t(status.text),
      statusColor: status.color
    };
  }
}
export default TransactionItem;
